import React, { useState, useEffect, useRef } from "react";
import andprlogo from "../asset/images/Logos/andprlogo.png";

const NAV_CSS = `
  @keyframes navIn {
    from { opacity: 0; transform: translateY(-100%); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes panelIn {
    from { transform: translateX(100%); }
    to   { transform: translateX(0); }
  }
  @keyframes mLinkIn {
    from { opacity: 0; transform: translateX(32px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes overlayIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .nd-nav {
    animation: navIn 0.55s cubic-bezier(0.22,1,0.36,1) both;
    position: fixed;
    top: 0; left: 0; right: 0;
    z-index: 100;
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: translateY(0);
  }

  .nd-nav.hidden {
    transform: translateY(-100%);
  }

  .nd-bar {
    transition: background 0.4s, box-shadow 0.4s, border-color 0.4s;
    border-bottom: 1px solid transparent;
    background: #000000;
  }
  .nd-bar.on {
    background: #000000;
    border-bottom-color: rgba(247,230,202,0.2);
    box-shadow: 0 1px 24px rgba(0,0,0,0.6);
  }

  .nd-link {
    position: relative;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    padding: 4px 0;
    letter-spacing: 0.05em;
    transition: color 0.2s;
    white-space: nowrap;
  }
  .nd-link::after {
    content: '';
    position: absolute;
    bottom: -2px; left: 0;
    height: 1.5px; width: 0;
    background: #F7E6CA;
    transition: width 0.25s ease;
    border-radius: 1px;
  }
  .nd-link:hover { color: #F7E6CA; }
  .nd-link:hover::after { width: 100%; }

  .nd-bar.on .nd-link { color: #ffffff; }
  .nd-bar.on .nd-link:hover { color: #F7E6CA; }

  .nd-toggle {
    width: 40px; height: 40px;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 5px;
    background: none; border: none; cursor: pointer;
    padding: 0; flex-shrink: 0;
  }
  .nd-toggle span {
    display: block;
    height: 1.5px;
    background: #ffffff;
    border-radius: 2px;
    transition: opacity 0.3s ease, transform 0.3s ease, background 0.4s;
    transform-origin: center;
  }

  .nd-toggle.open span:nth-child(1) { transform: translateY(6.5px) rotate(45deg); }
  .nd-toggle.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
  .nd-toggle.open span:nth-child(3) { transform: translateY(-6.5px) rotate(-45deg); }

  /* Default: show desktop logo, hide mobile logo */
  .nd-logo-left { display: flex; }
  .nd-logo-mobile { display: none; }

  @media (max-width: 767px) {
    .nd-desktop-nav  { display: none !important; }
    .nd-logo-left { display: none !important; }
    .nd-logo-mobile { display: flex !important; }
    .nd-bar {
      padding: 0 20px !important;
      justify-content: space-between !important;
    }
  }

  @media (min-width: 768px) {
    .nd-hamburger   { display: none !important; }
    .nd-logo-left { display: flex !important; }
    .nd-logo-mobile { display: none !important; }
  }

  /* Mobile panel — white bg, black text */
  .nd-mobile {
    position: fixed;
    top: 0; right: 0;
    width: min(360px, 100vw);
    height: 100dvh;
    background: #ffffff;
    z-index: 99;
    display: flex;
    flex-direction: column;
    animation: panelIn 0.4s cubic-bezier(0.22,1,0.36,1) forwards;
    padding: 88px 40px 48px;
    box-shadow: -24px 0 64px rgba(0,0,0,0.12);
    box-sizing: border-box;
  }
  .nd-mobile-link {
    font-size: 36px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.15);
    text-decoration: none;
    line-height: 1.2;
    letter-spacing: -1px;
    opacity: 0;
    animation: mLinkIn 0.35s ease forwards;
    transition: color 0.2s;
    display: block;
    padding: 6px 0;
  }
  .nd-mobile-link:hover { color: #000000; }

  .nd-overlay {
    position: fixed; inset: 0; z-index: 98;
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    animation: overlayIn 0.3s ease both;
    cursor: pointer;
  }

  .nd-mobile-bottom {
    margin-top: auto;
    padding-top: 40px;
    border-top: 1px solid rgba(0,0,0,0.1);
  }

  .nd-mobile-accent {
    width: 28px;
    height: 2px;
    background: #F7E6CA;
    border-radius: 1px;
    margin-bottom: 32px;
    margin-top: 52px;
  }

  /* ── Dropdown Submenu ── */
  .nd-nav-item-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 80px;
  }
  .nd-dropdown-menu {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);
    background: #000000;
    border: 0.5px solid rgba(247, 230, 202, 0.2);
    min-width: 280px;
    padding: 12px 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    z-index: 150;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  }
  .nd-nav-item-container:hover .nd-dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
  .nd-dropdown-item {
    display: block;
    padding: 12px 24px;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    font-family: var(--font-body, system-ui, sans-serif);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 500;
    transition: all 0.25s ease;
    text-align: left;
  }
  .nd-dropdown-item:hover {
    color: #F7E6CA;
    background: rgba(247, 230, 202, 0.04);
    padding-left: 28px;
  }
`;

const LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Work", href: "/work" },
  { label: "Case Studies", href: "/case-studies" },
  { label: "Services", href: "/services" },
  { label: "Insights", href: "/insights" },
  // { label: "Press", href: "/press" },
  { label: "Concierge", href: "/concierge" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [navVisible, setNavVisible] = useState(true);
  const [servicesMobileOpen, setServicesMobileOpen] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", fn, { passive: true });
    fn();
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 72) {
        setNavVisible(false);
      } else {
        setNavVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const close = () => {
    setOpen(false);
    setServicesMobileOpen(false);
  };

  return (
    <>
      <style>{NAV_CSS}</style>

      <div className={`nd-nav ${!navVisible ? "hidden" : ""}`}>
        {/* TOP BAR — champagne bg, black text */}
        <div style={{
          backgroundColor: "#F7E6CA",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px 0",
          borderBottom: "1px solid rgba(0,0,0,0.1)"
        }}>
          <a href="/concierge" style={{
            color: "#000000",
            textDecoration: "none",
            fontSize: "12px",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontWeight: 600,
          }}>
            Get In Touch With Us
          </a>
        </div>

        {/* MAIN BAR — black bg */}
        <div
          className={`nd-bar${scrolled ? " on" : ""}`}
          style={{
            width: "100%",
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0 48px",
            boxSizing: "border-box",
            position: "relative",
          }}
        >
          {/* LEFT LOGO — Desktop only */}
          <a
            href="/"
            className="nd-logo-left"
            style={{ display: "flex", alignItems: "center", textDecoration: "none", zIndex: 101, flexShrink: 0 }}
          >
            <img
              src={andprlogo}
              alt="And PR Agency"
              style={{ width: "60px", height: "60px", objectFit: "contain", filter: "brightness(0) invert(1)" }}
            />
          </a>

          {/* DESKTOP NAV — absolutely centered in the bar */}
          <nav
            className="nd-desktop-nav"
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              gap: "40px",
            }}
          >
            {LINKS.map((l) => {
              if (l.label === "Services") {
                return (
                  <div key={l.label} className="nd-nav-item-container">
                    <a href={l.href} className="nd-link">
                      {l.label}
                    </a>
                    <div className="nd-dropdown-menu">
                      {[
                        { name: "Brand Development", slug: "/luxury-brand-development" },
                        { name: "Branding & Packaging", slug: "/luxury-branding-packaging" },
                        { name: "Public Relations", slug: "/luxury-public-relations" },
                        { name: "Social Media Marketing", slug: "/luxury-social-media-marketing" },
                        { name: "Campaign Shoots", slug: "/luxury-campaign-shoots" },
                        { name: "Web Development", slug: "/luxury-web-development" }
                      ].map((sub) => (
                        <a key={sub.slug} href={sub.slug} className="nd-dropdown-item">
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </div>
                );
              }
              return (
                <a key={l.label} href={l.href} className="nd-link">
                  {l.label}
                </a>
              );
            })}
          </nav>

          {/* MOBILE LOGO */}
          <a
            href="/"
            className="nd-logo-mobile"
            style={{ display: "flex", alignItems: "center", textDecoration: "none", flexShrink: 0 }}
          >
            <img
              src={andprlogo}
              alt="And PR Agency"
              style={{ width: "48px", height: "48px", objectFit: "contain", filter: "brightness(0) invert(1)" }}
            />
          </a>

          {/* HAMBURGER */}
          <button
            className={`nd-hamburger nd-toggle${open ? " open" : ""}`}
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <span style={{ width: "22px" }} />
            <span style={{ width: "14px" }} />
            <span style={{ width: "22px" }} />
          </button>
        </div>
      </div>

      {/* Overlay */}
      {open && <div className="nd-overlay" onClick={close} />}

      {/* Mobile slide panel — white bg */}
      {open && (
        <div className="nd-mobile" role="dialog" aria-modal="true" aria-label="Navigation menu">
          {/* <div style={{ marginBottom: "8px" }}>
            <img
              src={andprlogo}
              alt="Logo"
              style={{ width: "36px", height: "36px", objectFit: "contain", filter: "brightness(0)", opacity: 0.9 }}
            />
          </div> */}

          <div className="nd-mobile-accent" />

          <div style={{ display: "flex", flexDirection: "column" }}>
            {LINKS.map((l, i) => {
              if (l.label === "Services") {
                return (
                  <div key={l.label} style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <a
                        href={l.href}
                        className="nd-mobile-link"
                        onClick={close}
                        style={{ animationDelay: `${i * 0.055}s`, flexGrow: 1 }}
                        onMouseOver={(e) => (e.currentTarget.style.color = "#000000")}
                        onMouseOut={(e) => (e.currentTarget.style.color = "rgba(0,0,0,0.15)")}
                      >
                        {l.label}
                      </a>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setServicesMobileOpen(!servicesMobileOpen);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "12px",
                          cursor: "pointer",
                          color: "rgba(0,0,0,0.4)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transform: servicesMobileOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          zIndex: 10
                        }}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                    </div>
                    
                    {/* Nested Submenu */}
                    <div style={{
                      maxHeight: servicesMobileOpen ? "400px" : "0",
                      opacity: servicesMobileOpen ? "1" : "0",
                      overflow: "hidden",
                      transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
                      paddingLeft: "20px",
                      borderLeft: "1px solid rgba(0,0,0,0.06)",
                      marginTop: servicesMobileOpen ? "8px" : "0",
                      marginBottom: servicesMobileOpen ? "16px" : "0",
                    }}>
                      {[
                        { name: "Brand Development", slug: "/luxury-brand-development" },
                        { name: "Branding & Packaging", slug: "/luxury-branding-packaging" },
                        { name: "Public Relations", slug: "/luxury-public-relations" },
                        { name: "Social Media Marketing", slug: "/luxury-social-media-marketing" },
                        { name: "Campaign Shoots", slug: "/luxury-campaign-shoots" },
                        { name: "Web Development", slug: "/luxury-web-development" }
                      ].map((sub) => (
                        <a
                          key={sub.slug}
                          href={sub.slug}
                          className="nd-mobile-sublink"
                          onClick={close}
                          style={{
                            display: "block",
                            padding: "8px 0",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "rgba(0,0,0,0.6)",
                            textDecoration: "none",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            transition: "color 0.2s"
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.color = "#C9A96E")}
                          onMouseOut={(e) => (e.currentTarget.style.color = "rgba(0,0,0,0.6)")}
                        >
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </div>
                );
              }
              
              return (
                <a
                  key={l.label}
                  href={l.href}
                  className="nd-mobile-link"
                  onClick={close}
                  style={{ animationDelay: `${i * 0.055}s` }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#000000")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "rgba(0,0,0,0.15)")}
                >
                  {l.label}
                </a>
              );
            })}
          </div>

          <div className="nd-mobile-bottom">
            <a
              href="/concierge"
              onClick={close}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "12px",
                color: "#000000",
                textDecoration: "none",
                fontSize: "12px",
                fontWeight: 700,
                letterSpacing: "0.09em",
                textTransform: "uppercase",
                opacity: 0,
                animation: `mLinkIn 0.35s ease ${LINKS.length * 0.055 + 0.1}s forwards`,
              }}
            >
              <span
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "50%",
                  background: "#F7E6CA",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  color: "#000000",
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                →
              </span>
              Let's Talk
            </a>
          </div>
        </div>
      )}
    </>
  );
}